import { designTokens } from "@benyishiguang/ui-foundation";
import type { CSSProperties } from "react";

// H5 uses a compact reading scale; do not shrink controls or other clients.
export const webTypography = {
	...designTokens.typography,
	title: { fontSize: 24, lineHeight: 32 },
	heading: { fontSize: 18, lineHeight: 26 },
	cardTitle: { fontSize: 16, lineHeight: 24 },
	caption: { fontSize: 13, lineHeight: 20 },
};

/** Web units are assigned here; the shared package remains renderer-independent. */
export const growthTokenStyle = {
	...Object.fromEntries(
		Object.entries(designTokens.colors).map(([name, value]) => [`--brand-${name}`, value]),
	),
	...Object.fromEntries(
		Object.entries(designTokens.space).map(([name, value]) => [
			`--growth-space-${name}`,
			`${value}px`,
		]),
	),
	...Object.fromEntries(
		Object.entries(designTokens.radius).map(([name, value]) => [
			`--growth-radius-${name}`,
			`${value}px`,
		]),
	),
	...Object.fromEntries(
		Object.entries(designTokens.size).map(([name, value]) => [
			`--growth-size-${name}`,
			`${value}px`,
		]),
	),
	...Object.fromEntries(
		Object.entries(webTypography).flatMap(([name, value]) => [
			[`--growth-font-${name}`, `${value.fontSize}px`],
			[`--growth-line-${name}`, `${value.lineHeight}px`],
		]),
	),
} as CSSProperties;
